/**
 * 字典相关
 */

import { queryDictItems } from '@/api/manage';
import { UI_CACHE_DB_DICT_DATA } from '@/store/mutation-types';
import Vue from 'vue';

/**
 * 获取缓存中字典
 * @param dictCode
 * @returns {*[]|*}
 */
export const getDictItemsFromCache = dictCode => {
    if (Vue.ls.get(UI_CACHE_DB_DICT_DATA) && Vue.ls.get(UI_CACHE_DB_DICT_DATA)[`${dictCode}`]) {
        return Vue.ls.get(UI_CACHE_DB_DICT_DATA)[`${dictCode}`];
    }
    else {
        return [];
    }
};

/**
 * 根据字典值获取字典数组
 * @param dictCode 字典Code
 * @return List<Map>
 */
export const initDictOptions = async dictCode => {
    if (!dictCode) {
        return '字典Code不能为空!';
    }
    // 优先从缓存中读取字典配置
    let arr = getDictItemsFromCache(dictCode);
    if (arr && arr.length !== 0) {
        let res = {};
        res.result = getDictItemsFromCache(dictCode);
        res.success = true;
        return res;
    }
    else {
        return await queryDictItems(dictCode);
    }
};

/**
 * 字典选项值转换对应文本
 * @param dictCode
 * @param key
 * @returns {string|boolean|*}
 */
export const filterDictTextByCache = (dictCode, key) => {
    if (key === null || key.length === 0) {
        return false;
    }
    if (!dictCode) {
        return '字典Code不能为空!';
    }
    if (getDictItemsFromCache(dictCode)) {
        let item = getDictItemsFromCache(dictCode).filter(t => t['value'] === key.toString());
        if (item && item.length > 0) {
            return item[0]['text'];
        }
    }
    else {
        return '-';
    }
};

export default {
    initDictOptions,
    filterDictTextByCache,
};
